import { useIntl } from "react-intl";
import { ITruckerPayPlanData } from "../../../../models/truckerPayPlan";
import "./styles.scss";

export interface ICoverageBalanceProps {
  truckerPayPlan?: ITruckerPayPlanData | null;
}

const CoverageBalance = ({ truckerPayPlan }: ICoverageBalanceProps) => {
  const intl = useIntl();
  const total = (truckerPayPlan?.coverageQuantity ?? 0).toLocaleString(intl.locale, { style: "currency", currency: "BRL" });
  const totalUsed = ((truckerPayPlan?.coverageTotalUsed ?? 0) + (truckerPayPlan?.coverageReserved ?? 0)).toLocaleString(intl.locale, { style: "currency", currency: "BRL" });
  const availableBalance = (truckerPayPlan?.availableCoverageBalance ?? 0).toLocaleString(intl.locale, { style: "currency", currency: "BRL" });

  return (
    <section>
      <div className="contract-details-saldo-card">
        <div className="contract-details-saldo-card__left">
          <span className="rioglyph rioglyph-cog contract-details-saldo-card__icon" aria-hidden />
          <div className="contract-details-saldo-card__text">
            <h2 className="contract-details-saldo-card__title">
              {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.coverageBalance.title" })}
            </h2>
          </div>
        </div>

        <div className="flex gap-8">
          <div>
            <div className="contract-details-saldo-card__balance-label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.coverageBalance.expected" })}</div>
            <div className="flex border border-color-black border-right-only border-width-2 !pr-8">
              <div className="contract-details-saldo-card__total">
                {total}
              </div>
            </div>
          </div>

          <div>
            <div className="contract-details-saldo-card__balance-label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.coverageBalance.used" })}</div>
            <div className="flex border border-color-black border-right-only border-width-2 !pr-8">
              <div className="contract-details-saldo-card__balance">
                {totalUsed}
              </div>
            </div>
          </div>
          
          <div>
            <div className="contract-details-saldo-card__balance-label">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.coverageBalance.available" })}</div>
            <div className="contract-details-saldo-card__balance">
              {availableBalance}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

export default CoverageBalance;
